import src from "IMAGE";
export default { src, width: 210, height: 125, blurWidth: 0, blurHeight: 0};
